export default __webpack_public_path__ + "static/media/Resources.b663e2d6.svg";